<template>
  <div>
    <canvas :id="'chart-' + product.id"></canvas>
  </div>
</template>

<script>


export default {
  name: 'HorizontalBarChart',
  props: ['product'],
  mounted() {
    const ctx = document
      .getElementById('chart-' + this.product.id)
      .getContext('2d')
    this.renderChart(ctx)
  },
  methods: {
    renderChart(ctx) {
      const barThickness = 23
      const borderWidth  = 2
      const borderRadius = 10

      
const drawCategoryLabels = {
  id: 'drawCategoryLabels',
  afterDatasetsDraw(chart) {
    const ctx = chart.ctx;
    ctx.save();
    ctx.font      = '16px ${bsSans}';
    ctx.fillStyle = '#000';
    ctx.textAlign   = 'left';
    ctx.textBaseline= 'bottom';


    const meta0 = chart.getDatasetMeta(0);

    chart.data.labels.forEach((label, i) => {
      const bar = meta0.data[i];
      const x = chart.chartArea.left;
      const y = bar.y - (bar.height / 2);
      ctx.fillText(label, x, y);
    });

    ctx.restore();
  }
};


new Chart(ctx, {
  type: 'bar',
  data: {
    labels: ['Gaming', 'Filme', 'Sport'],
    datasets: [
      {
        // Dataset 0: 100%-Hintergrund (ohne datalabels)
        data: [10,10,10],
        backgroundColor: 'rgba(237, 237, 237, 0.3)',
        barThickness: 25,
        borderRadius: 25,
        //borderColor: '#333',
        borderWidth: 0.8,
        borderColor: '#333',
        borderSkipped: false,
        order: 0,
        grouped: false,
        categoryPercentage:1,
        barPercentage:1,
        
      },
      {
        
        data: [
  Number(this.product.videogameval).toFixed(1),
  Number(this.product.hdrvideoval).toFixed(1),
  Number(this.product.sportsval).toFixed(1)
].map(Number),
        backgroundColor: ['rgba(255, 166, 166, 1)','rgba(166, 188, 255, 1)','rgba(255, 253, 125, 1)'],
        borderColor: '#333',
        borderWidth: { top: 1, bottom: 1, left: 0, right: 1 },
        barThickness: 25,
        borderRadius: 25,
        borderSkipped: false,
        order: 1,
        grouped: false,
        categoryPercentage:1,
        barPercentage:1,
        datalabels: {
          display: true,
          //formatter: v => v + ' %',
          anchor: 'center',
          align:  'right',
          color: '#333',
          font: { size: 20},
          clamp: false
        }
      }
    ]
  },

  plugins: [ ChartDataLabels, drawCategoryLabels ],

  options: {
  responsive: true,           // Chart passt sich der Größe des Canvas-Containers an
  maintainAspectRatio: false, // erlaubt es, die Höhe unabhängig von der Breite zu steuern
  layout: { padding: { left: 20, right: 20, top: 10} },
  indexAxis: 'y',
  plugins: {
    legend:  { display: false },
    tooltip: { filter: item => item.datasetIndex === 1 },
    datalabels: {
      display: ctx => ctx.datasetIndex === 1,
      anchor: 'center',
      align:  'right',
      color: '#333',
      font: { size: 18 },
      clamp: false
    }
  },
  scales: {
    y: { display: false },
    x: { display: false, min:0, max:10 }
  }
}
});
    }
  }
}
</script>